import React, { useEffect, useRef, useState, useCallback } from 'react';
import _ from 'lodash';
import { useLocation } from 'react-router';
import { scroll } from './helper';

const useAfterDidMountEffect = (func, deps) => {
  //首次不渲染
  const didMount = useRef(false);
  useEffect(() => {
    if (didMount.current) func();
    else didMount.current = true;
  }, deps);
};
const useDidMountEffect = (func, deps) => {
  // 就首次渲染
  const didMount = useRef(false);
  useEffect(() => {
    if (!didMount.current) func();
    else didMount.current = true;
  }, deps);
};
let evtTarget;

try {
  evtTarget = new EventTarget();
} catch {
  evtTarget = document.createElement('phony');
}
const useStorage = (storage) => (key, defaultValue) => {
  const raw = storage.getItem(key);

  const [value, setValue] = useState(raw ? JSON.parse(raw) : defaultValue);

  const updater = (updatedValue, remove = false) => {
    setValue(updatedValue);
    storage[remove ? 'removeItem' : 'setItem'](
      key,
      JSON.stringify(updatedValue),
    );
    evtTarget.dispatchEvent(
      new CustomEvent('storage_change', { detail: { key } }),
    );
  };

  if (defaultValue != null && !raw) updater(defaultValue);

  useEffect(() => {
    const listener = ({ detail }) => {
      if (detail.key === key) {
        const lraw = storage.getItem(key);

        if (lraw !== raw) setValue(JSON.parse(lraw));
      }
    };

    evtTarget.addEventListener('storage_change', listener);
    return () => evtTarget.removeEventListener('storage_change', listener);
  });

  return [value, updater, () => updater(null, true)];
};
function ChangeSize(id) {
  const [size, setSize] = useState(1440);

  const onResize = useCallback(() => {
    if (document.getElementById(id)) {
      setSize(document.getElementById(id).clientWidth);
    } else {
      setSize(1440);
    }
  }, []);
  // const onResize = () => {
  //   console.log(123);
  // };

  useEffect(() => {
    window.addEventListener('resize', _.debounce(onResize, 300));

    const _w = document.getElementById(id).clientWidth;
    if (_w !== size) {
      setSize(document.getElementById(id).clientWidth);
    }

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return size;
}

export const useLocalStorage = useStorage(localStorage);
const useReactPath = () => {
  const [path, setPath] = React.useState(window.location.pathname);
  const listenToPopstate = () => {
    const winPath = window.location.pathname;
    setPath(winPath);
  };
  React.useEffect(() => {
    window.addEventListener('popstate', listenToPopstate);
    return () => {
      window.removeEventListener('popstate', listenToPopstate);
    };
  }, []);
  return path;
};
function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
const useScrollToTop = () => {
  const _l = useLocation();

  const { pathname } = _l;

  useEffect(() => {
    scroll('tcContentTop'); //scrollTo Bug TODO
  }, [pathname]);
  return null;
};

function useDebounce<T>(value: T, delay?: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay || 500);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}

const useComponentMemo = (Component, deps) => {
  return React.useMemo(() => {
    return Component;
  }, deps);
};

export {
  useAfterDidMountEffect,
  ChangeSize,
  useReactPath,
  useDidMountEffect,
  usePrevious,
  useScrollToTop,
  useDebounce,
  useComponentMemo,
};
